/* eslint-disable no-eq-null */

import { LinkEvent, nameForDocument, useAnalyticLinkDispatch } from "analytics/Analytics";
import * as React from "react";

export interface ExternalLinkProps extends React.HTMLProps<HTMLElement> {
    href: string;
    showIcon?: boolean;
    openInSelf?: boolean;
    onClick?: () => void;
    className?: string;
}

const ExternalLink: React.SFC<ExternalLinkProps> = (props: ExternalLinkProps) => {
    const linkRef = React.useRef<HTMLAnchorElement | null>(null);
    const dispatchLink = useAnalyticLinkDispatch();

    if (props.href == null) {
        return null;
    }

    const onClick = (e: React.MouseEvent<HTMLAnchorElement, {}>) => {
        if (props.onClick) {
            props.onClick();
        }

        if (linkRef.current) {
            const ev: LinkEvent = {
                linkLabel: linkRef.current.innerText,
                documentUrl: formatUrl(props.href),
            };

            dispatchLink(nameForDocument(props.href), ev);
        }
        e.stopPropagation();
    };

    const linkProps = props.openInSelf ? { target: "_self" } : { target: "_blank", rel: "noopener noreferrer" };

    return (
        <a ref={linkRef} className={props.className} href={formatUrl(props.href)} {...linkProps} onClick={onClick}>
            {props.children}
            {props.showIcon && <em style={{ marginLeft: "0.250rem" }} className="fa fa-external-link" aria-hidden="true" />}
        </a>
    );
};

ExternalLink.defaultProps = {
    showIcon: true,
    openInSelf: false,
};

export function formatUrl(href: string) {
    if (parseUrl(href)) {
        return href;
    }
    return "https://g.octopushq.com/" + href;

    function parseUrl(url: string): boolean {
        try {
            // We need these .startsWith checks because IE11 will assume URL("someString") is relative to the current
            // domain and won't throw (like every other browser in the universe).
            if (url.startsWith("http://") || url.startsWith("https://")) {
                const ignored = new URL(url);
                return true;
            } else {
                return false;
            }
        } catch (error) {
            return false;
        }
    }
}

export default ExternalLink;
